import bemBlock from '@gik/core/utils/bemBlock';
import React from 'react';
import type { ImageOnLoadingCompleteCallback } from '../Image';
import { Image } from '../Image';
import type { ProportionSetting } from './KeepProportions';
import { KeepProportions, Portrait, Wide } from './KeepProportions';

export interface IKeepProportionRangeProps {
  proportionUpper?: ProportionSetting;
  proportionLower?: ProportionSetting;
  className?: string;
  src?: string;
  onImageClick?: () => void;
  containType?: string;
}

const blockName = 'keep-proportions';

export function KeepProportionRange({
  proportionUpper = Portrait,
  proportionLower = Wide,
  src,
  onImageClick,
  className,
}: React.PropsWithChildren<IKeepProportionRangeProps>) {
  const bem = bemBlock(blockName);
  const mainRef = React.useRef<HTMLDivElement>(null);

  const [isLoading, setIsLoading] = React.useState<boolean>(true);
  // const [naturalWidth, setNaturalWidth] = React.useState<number>();
  // const [naturalHeight, setNaturalHeight] = React.useState<number>();
  const [proportion, setProportion] = React.useState<number>();

  const handleLoadingComplete: ImageOnLoadingCompleteCallback = React.useCallback(
    result => {
      // setNaturalWidth(result.naturalWidth);
      // setNaturalHeight(result.naturalHeight);

      const naturalProportion = result.naturalHeight / result.naturalWidth;

      switch (true) {
        case naturalProportion < proportionLower:
          setProportion(Wide);
          break;
        case naturalProportion > proportionUpper:
          setProportion(Portrait);
          break;
        default:
          setProportion(undefined);
      }

      setIsLoading(false);
    },
    [setIsLoading, proportionLower, proportionUpper]
  );

  return (
    <div className={bem(null, null, className)} ref={mainRef}>
      {proportion && <KeepProportions proportion={proportion} src={src} onImageClick={onImageClick} />}

      {!proportion && <Image src={src} onClick={onImageClick} />}

      {isLoading && <Image loadingSpinner src={src} onLoadingComplete={handleLoadingComplete} />}
    </div>
  );
}
